// Family Library section (Parent Dashboard): Storybook Vault + Achievements
// tabs. The Achievements trigger shows "Achievements (N)" for unseen
// certificates and clears once the parent visits the tab.
import { useEffect, useState } from "react";
import { Library } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { api } from "../../lib/api";
import { StorybookVault } from "../vault/StorybookVault";
import { AchievementsPanel } from "./AchievementsPanel";
import { LensJournal } from "./LensJournal";

export const FamilyLibrary = () => {
  const [newCount, setNewCount] = useState(0);
  const [comp, setComp] = useState(null);
  useEffect(() => {
    api.get("/achievements/summary")
      .then(({ data }) => setNewCount(data.new_count || 0))
      .catch(() => {});
    api.get("/story/comprehension/summary")
      .then(({ data }) => setComp(data)).catch(() => {});
  }, []);
  return (
    <section data-testid="family-library-section">
      <h2 className="text-base md:text-lg font-bold font-display flex items-center gap-2 mb-4">
        <Library className="h-5 w-5 text-secondary" aria-hidden="true" /> Family library
      </h2>
      {comp?.total > 0 && (
        <p className="text-xs text-muted-foreground mb-3" data-testid="comprehension-summary">
          Story comprehension checks: {comp.first_try_correct} of {comp.total} correct on the first try
        </p>
      )}
      <Tabs defaultValue="vault">
        <TabsList className="mb-4">
          <TabsTrigger value="vault" data-testid="tab-vault">Storybook Vault</TabsTrigger>
          <TabsTrigger value="achievements" className="relative" data-testid="tab-achievements">
            {newCount > 0 ? `Achievements (${newCount})` : "Achievements"}
            {newCount > 0 && (
              <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-amber-400 animate-pulse" aria-hidden="true" data-testid="achievements-badge-dot" />
            )}
          </TabsTrigger>
          <TabsTrigger value="words" data-testid="tab-word-journal">Word Journal</TabsTrigger>
        </TabsList>
        <TabsContent value="vault"><StorybookVault /></TabsContent>
        <TabsContent value="achievements">
          <AchievementsPanel onSeen={() => setNewCount(0)} />
        </TabsContent>
        <TabsContent value="words"><LensJournal /></TabsContent>
      </Tabs>
    </section>
  );
};
